import React, {useContext, useState} from "react";
import {useLocation, useParams} from "react-router-dom";
import {AdvertisementZeus, InputAsset, Asset, AdNew} from "./AdvertisementModelZeus";
import {useHistory} from "react-router-dom";
import GenericTemplate from "../../../templates/GenericTemplate";
import {ApiResponse, ApolloAxios, getResultType, isSuccessApi} from "../../../atom/Apollo_ApiRequest3";
import {
  APOLLO_SYSTEM_ADMIN,
  APOLLO_GROUP_OPERATOR,
  ApolloPageUsagePermission
} from "../../../atom/Apollo_Authorization";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";
import {ApolloMessage, CustomizedSnackbars} from "../../../atom/Apollo_Mesasge";
import {
  advertisements_path,
  get_zeus_ads
} from "../../../atom/Apollo_links";
import {ApolloContext} from "../../../atom/Apollo_Context";
import AdvertisementFormZeus from "./AdvertisementFormZeus";
import {getSubjectStrCheckErrorMsg, getTextStrCheckErrorMsg, getImageSizeType} from "../../../common/Apollo_CommonUtil";
import { AdTitle, AdDescription, AdImage, AdVideo, AdTag, ZeusAd, AdGroupRow } from "../../ADGROUP/zeus/AdGroupModelZeus";
import { LogData, ApolloEventRecord, createLogDate, ItemList } from "../../../atom/Apollo_EventRecord";

import moment from "moment";
import {
    ZEUS_DELIVERY_TYPE,
    options_zeus_campaign_type,
    ZEUS_AD_TYPE,
    valueToOptionNull,
    ZEUS_PMP_TYPE,
} from "../../../atom/Apollo_styles";
import {BLANK} from "../../ACCOUNT/sh/common/CommonConst";

// const formHooks = useForm<FormData>();
// const { register, handleSubmit, errors, control, formState } = formHooks;

// 画面名：広告作成（Zeus）
const AdvertisementCreateZeus: React.FC = () => {
  
  const history = useHistory();
  const {state} = useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const {accountgroupid, accountid, platformaccountid} = useParams<{
    accountgroupid: string,
    accountid: string,
    platformaccountid: string,
  }>();

  const [assets, setAssets] = useState<InputAsset>({
    imageId: 0,
    title: "",
    description: ""
  });
  const [imageUrl, setImageUrl] = useState("");
  const reqParams = new URLSearchParams(useLocation().search);
  const campaignId = reqParams.get("campaignId") ?? "0";
  const adGroupId = reqParams.get("adGroupId") ?? "0";
  const queryCampaignId = campaignId !== "0" ? `?campaignId=${campaignId}` : "";
  const queryAdGroupId = queryCampaignId !== "" ?
    adGroupId !== "0" ? `${queryCampaignId}&adGroupId=${adGroupId}` : `?campaignId=${campaignId}` :
    adGroupId !== "0" ? `?adGroupId=${adGroupId}` : "";

  // タブ制御
  const [tabstate, setTabstate] = React.useState( 0 );
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
      setTabstate(newValue);
  };

  // クリエイティブ登録・編集
  const [titleIndexes, setTitleIndexes] = useState([1]);
  const [descriptionIndexes, setDescriptionIndexes] = useState([1]);
  const [imageIndexes, setImageIndexes] = useState([1]);
  const [tagIndexes, setTagIndexes] = useState([1]);
  // const [movieIndexes, setMovieIndexes] = useState([1]);

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 25,
    breadId: 2,
    queries: ["", "", "", "", queryCampaignId, queryAdGroupId],
    menu: {
      id: 1,
      accountId: platformaccountid,
      accountName: "",
    },
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }


  const [advertisement, setAdvertisement] = useState<AdvertisementZeus>({
    id: 0,
    createdAt: "",
    updatedAt: "",
    lastUpdateUserId: "",
    adAccountId: 0,
    adCampaignId: campaignId !== "0" ? Number(campaignId) : 0,
    adGroupId: adGroupId !== "0" ? Number(adGroupId) : 0,
    name: "",
    adType: 1,
    status: 2,
    link: "",
    customUrl: "",
    sponsor: "",
    cta: 1,
    sponsorDomain: "",
    titles: [],
    descriptions: [],
    images: [],
    videos: [],
    apps: [],
    mails: [],
    tags: [],
    adAccountName: "",
    adCampaignName: "",
    adGroupName: "",
    reviewStatus: 0,
    reviewReason: 0,
    reviewStatusForView: 0,
  });

  const initZeusAds : ZeusAd = {
    id: 0,
    createdAt: "",
    updatedAt: "",
    lastUpdateUserId: "",
    adAccountId: 0,
    adCampaignId: campaignId !== "0" ? Number(campaignId) : 0,
    adGroupId: adGroupId !== "0" ? Number(adGroupId) : 0,
    name: "",
    status: 2,
    link: "",
    customUrl: "",
    sponsor: "",
    cta: 0,
    titles: [],
    descriptions: [],
    images: [],
    videos: [],
    apps: [],
    mails: [],
    tags: [],
    adAccountName: "",
    adCampaignName: "",
    adGroupName: "",
    reviewStatus: 0,
    reviewReason: 0,
    reviewStatusForView: 0,
};

const initAdGroupRow: AdGroupRow = {
    id: 0,
    createdAt: "",
    updatedAt: "",
    lastUpdateUserId: "",
    adAccountId: 0,
    adCampaignId: 0,
    name: "",
    status: 2,
    cpcLimit: null,
    eventRelations: [],
    osTargetings: [],
    demographicRelations: [],
    audienceRelations: [],
    segmentRelations: [],
};
// 編集用
const [deliveryType, setDeliveryType] = useState(ZEUS_DELIVERY_TYPE.PERFORMANCE);
const [pmpType, setPmpType] = useState<number | null>(null);
const [placementSettingId, setPlacementSettingId] = useState<number>(0);

const [titles, setTitles] = useState<AdTitle[]>([{text:""}]);
const [isAddedTitle, setIsAddedTitle] = useState(false);

const [descriptions, setDescriptions] = useState<AdDescription[]>([{text:""}]);
const [isAddedDescription, setIsAddedDescription] = useState(false);

const [images, setImages] = useState<AdImage[]>([]);
const [isAddedImage, setIsAddedImage] = useState(false);

const [videos, setVideos] = useState<AdVideo[]>([]);
const [isAddedVideo, setIsAddedVideo] = useState(false);

const [tags, setTags] = useState<AdTag[]>([]);
const [isAddedTag, setIsAddedTag] = useState(false);

const [selectedFileOrigins, setSelectedFileOrigins] = useState<string[]>([""]);
/**
 * クリエイティブの入力フォームのindexを増やす。
 * @param {number} indexType - クリエイティブタイプ 1:見出し, 2:説明文, 3:画像, 4:動画
 */
    function addIndexes(indexType: number) {
    switch (indexType){
    case 1: // 見出し
        // @ts-ignore
        setTitleIndexes(current => [...current, current.length > 0 ? Math.max(...current) + 1 : 0]);
        break;
    case 2: // 説明文
        // @ts-ignore
        setDescriptionIndexes(current => [...current, current.length > 0 ? Math.max(...current) + 1 : 0]);
        break;
    case 3: // 画像
        // @ts-ignore
        setImageIndexes(current => [...current, current.length > 0 ? Math.max(...current) + 1 : 0]);
        break;
    case 4: // 動画
        // // @ts-ignore
        // setMovieIndexes(current => [...current, current.length > 0 ? Math.max(...current) + 1 : 0]);
        break;
    default:
    }
}

  const handleSubmit = async ( data : any ) => {
    console.log("handleSubmit");

    let isSuccess = false;
    const body = {}
    let listImages: AdImage[] = [];

    let listTitles: AdTitle[] = [];
    let isError1 = false;
    
    console.log(titles);
    if (titles.length !== 0) {
        // 見出しが必須となる広告種別でのみ判定を行う
        if (advertisement.adType === ZEUS_AD_TYPE.RESPONSIVE_IMAGE) {
            let titleCount = 0;
            let title1 : string = "";
            let title2 : string = "";
            titles.forEach(function(v: AdTitle) {
                let title = v.text ? v.text: ""
                const errorMessage = getSubjectStrCheckErrorMsg(title);
                if (errorMessage) {
                    setmsg ({
                        type: "setMessage",
                        payload: {
                            ...data,
                            open: true,
                            type: "error",
                            message: "見出しに禁止文字が入力されています。"
                    }});
                    isError1 = true;
                }
    
                if(title1 == title || title2 == title){
                    setmsg ({
                        type: "setMessage",
                        payload: {
                            ...data,
                            open:true,
                            type:"error",
                            message:"同じ見出しが複数設定されています。"
                    }});
    
                    isError1 = true;
                }
                if((v.text ?? "") !== "" && titleCount == 0) {
                    title1 = v.text ?? "";
                }
                if(titleCount == 1) {
                    title2 = v.text ?? "";
                }
                titleCount++;
                if((v.text ?? "") !== "" ){
                  listTitles.push({text: v.text?? ""})
                }
            });
        }
    } else {
        setmsg ({
            type: "setMessage",
            payload: {
                ...data,
                open:true,
                type:"error",
                message:"見出しを入力してください。"
        }});
        isError1 = true;
    }

    let listDescriptions: AdDescription[] = [];
    console.log(descriptions);
    if (descriptions.length !== 0) {
        // 説明文が必須となる広告種別でのみ判定を行う
        if (advertisement.adType === ZEUS_AD_TYPE.RESPONSIVE_IMAGE) {
            let descriptionCount = 0;
            let description1 : string = "";
            let description2 : string = "";
            descriptions.forEach(function(v: AdDescription) {     
            
                let description = v.text   
                const errorMessage = getTextStrCheckErrorMsg(description);
                if (errorMessage) {
                    setmsg ({
                        type: "setMessage",
                        payload: {
                            ...data,
                            open: true,
                            type: "error",
                            message: "説明文に禁止文字が入力されています。"
                    }});
                    isError1 = true;
                }

                if(description1 == description || description2 == description){
                    setmsg ({
                        type: "setMessage",
                        payload: {
                            ...data,
                            open:true,
                            type:"error",
                            message:"同じ説明文が複数設定されています。"
                    }});

                    isError1 = true;
                }
                if(description !== "" && descriptionCount == 0) {
                    description1 = description;
                }
                if(description !== "" && descriptionCount == 1) {
                    description2 = description;
                }
                descriptionCount++;    
                if((v.text ?? "") !== "" ){
                    listDescriptions.push({text: v.text?? ""})
                }
            });
        }
    } else {
        setmsg ({
            type: "setMessage",
            payload: {
                ...data,
                open:true,
                type:"error",
                message:"説明文を入力してください。"
        }});
        isError1 = true;
    }
    if (selectedFileOrigins.length !== 0) {
        let isSameAspectError = false;
        //  広告種別がタグアセット広告(動画)の場合は除外
        if (advertisement.adType !== ZEUS_AD_TYPE.TAG_ASSET_VIDEO) {
            if(ZEUS_PMP_TYPE.PLACEMENT_DESIGNATION == pmpType || ZEUS_PMP_TYPE.PREMIUM_PLACEMENT_DESIGNATION == pmpType) {
                let imageSizeTypeList: number[] = [];
    
                selectedFileOrigins.forEach(function(textImage: string){
                    let r1 = textImage.split(" ");
    
                    let w1 = r1[1].replace("(幅", "").replace(",", "");
                    let width = parseInt(w1);
    
                    let h1 = r1[2].replace("高さ", "").replace(")", "");
                    let height = parseInt(h1);
    
                    let imageSizeType = getImageSizeType(width, height);
                    imageSizeTypeList.push(imageSizeType);
    
                    let id1 = r1[0].replace("img", "");
                    let id2 = parseInt(id1);
                    listImages.push({adAccountImageResourceId: id2});
                })
    
                // 重複チェック(一意のリストを用意し、リストの要素数が一致するかでチェック)
                const uniqueImageSizeTypeList: number[] = Array.from(new Set(imageSizeTypeList));
                if(uniqueImageSizeTypeList.length != imageSizeTypeList.length) {
                    isSameAspectError = true;
                }
            } else {
                let aspectCount1_1 = 0;
                let aspectCount1_9 = 0;
        
                selectedFileOrigins.forEach(function(v: string){
                    let r1 = v.split(" ");
        
                    let w1 = r1[1].replace("(幅", "").replace(",", "");
                    let width = parseInt(w1);
        
                    let h1 = r1[2].replace("高さ", "").replace(")", "");
                    let height = parseInt(h1);
        
                    let aspect =  Math.round(width * 10 / height) / 10;
        
                    if (aspect === 1) {
                        aspectCount1_1++;
                    } else if(aspect === 1.9) {
                        aspectCount1_9++;
                    }
        
                    if (aspectCount1_1 >= 2 || aspectCount1_9 >= 2) {
                        isSameAspectError = true;
                    }
                    let id1 = r1[0].replace("img", "");
                    let id2 = parseInt(id1);
                    listImages.push({adAccountImageResourceId: id2});
                })
            }
        }
        if(isSameAspectError) {
            setmsg ({
                type: "setMessage",
                payload: {
                    ...data,
                    open:true,
                    type:"error",
                    message:"同じ縦横比の画像は1広告1枚まで選択可能です。"
            }});
            isError1 = true;
            return;
        }
    } else {
        setmsg ({
            type: "setMessage",
            payload: {
                ...data,
                open:true,
                type:"error",
                message:"画像を選択してください。"
        }});
        isError1 = true;
    }
    
    console.log(tags);
    let listTags: AdTag[] = [];
    // 広告種別がタグアセット広告(動画)でのみ判定を行う
    if (advertisement.adType === ZEUS_AD_TYPE.TAG_ASSET_VIDEO){
        if (tags.length !== 0) {
            tags.forEach(function(v: AdTag) {
                listTags.push({adAccountTagResourceId: v.adAccountTagResourceId?? 0})
            });
        //     listTags.push({adAccountTagResourceId: tags.adAccountTagResourceId ?? 0})
        } else {
            setmsg ({
                type: "setMessage",
                payload: {
                    ...data,
                    open:true,
                    type:"error",
                    message:"タグアセットを選択してください。"
            }});
            isError1 = true;
        }
    }

    if (isError1) {
        return;
    }

    // let listMovies: AdVideo[] = [];
    // if (Object.keys(data).indexOf('movies') !== -1) {
    //     advertisement.movies.forEach(function(v: any){
    //         let r1 = v.replace("d", "");
    //         let r2 = parseInt(r1);
    //         listMovies.push({adAccountVideoResourceId: r2});
    //     });
    // }
      
    const items : ItemList[] = [
        {key:"キャンペーン種別", beforeValue: "", afterValue: valueToOptionNull(deliveryType, options_zeus_campaign_type)?.label ?? ""},
        {key:"広告種別", beforeValue:"", afterValue: advertisement.adType.toString()},
        {key:"広告名", beforeValue:"", afterValue: advertisement.name},
        {key:"ステータス", beforeValue:"", afterValue: advertisement.status.toString()},
        {key:"最終リンク先URL", beforeValue:"", afterValue: advertisement.link},
        {key:"情報提供者ドメイン", beforeValue:"", afterValue: advertisement.sponsorDomain},
        {key:"情報提供者名", beforeValue:"", afterValue: advertisement.sponsor},
        {key:"ClickToAction", beforeValue:"", afterValue: advertisement.cta ? advertisement.cta.toString() : ""},
        {key:"クリエィテイブ情報（見出し）", beforeValue:"", afterValue: listTitles?.length == 1 ?  "[" + listTitles[0].text  + "]" : listTitles?.length == 1 ? "" : "[" + listTitles.filter((output: any) => {
          return output !== [];
        }).join("、") + "]"},
        {key:"クリエィテイブ情報（説明文）", beforeValue:"", afterValue: listDescriptions?.length == 1 ?  "[" + listDescriptions[0].text  + "]" : listDescriptions?.length == 0 ? "" : "[" + listDescriptions.filter((output: any) => {
          return output !== [];
        }).join("、") + "]"},
        {key:"クリエィテイブ情報（広告アセット選択）", beforeValue:"", afterValue: listImages?.length == 1 ?  "[" + listImages[0].adAccountImageResourceId.toString() + "]" : listImages?.length == 0 ? "" : "[" + listImages.filter((output: any) => {
          return output !== [];
        }).map((value) => value.adAccountImageResourceId).join("、") + "]"},
        {key:"クリエィテイブ情報（広告タグアセット選択）", beforeValue:"", afterValue: listTags?.length == 1 ?  "[" + listTags[0].adAccountTagResourceId.toString() + "]" : listTags?.length == 0 ? "" : "[" + listTags.filter((output: any) => {
          return output !== [];
        })
        .map((value) => value.adAccountTagResourceId).join("、") + "]"},
    ];
  
    const executeLogData = createLogDate(
        state,
        "パフォーマンス広告",
        "広告",
        "作成",
        "広告(パフォーマンス広告)作成",
        items,
        advertisement.adCampaignId.toString(),
        advertisement.adCampaignName,
        advertisement.adGroupId.toString(),
        advertisement.adGroupName
    );
    executeLogData.targetID = "";
    executeLogData.targetName = "";
    ApolloEventRecord({...executeLogData, logType: "execute"});
    // console.log(executeLogData);

    const url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_ads}`;

    const adsCreateRequest: AdNew = {
        adAccountId: parseInt(platformaccountid),
        adCampaignId: advertisement.adCampaignId,
        adGroupId: advertisement.adGroupId,
        adType: advertisement.adType,
        name: advertisement.name,
        status: advertisement.status,
        link: advertisement.link,
        customUrl: null,
        sponsor: advertisement.sponsor,
        cta: advertisement.adType === ZEUS_AD_TYPE.RESPONSIVE_IMAGE ? advertisement.cta : null,
        sponsorDomain: advertisement.sponsorDomain,
        titles: listTitles,
        descriptions: listDescriptions,
        images: listImages,
        videos: [],
        apps: [],
        mails: [],
        tags:listTags,
    }


    let registedId = BLANK;
    await ApolloAxios.post(url, adsCreateRequest).then((response) => {
        const res: ApiResponse = response.data;
        if (!isSuccessApi(res.resultCode)) {
            return Promise.reject({
                open: true,
                type: getResultType(res.resultCode),
                errmsg: res?.message ? res.message : "広告新規作成に失敗しました",
            });
        } else {
            registedId = response.data.id?.toString() ?? BLANK
        }

        isSuccess = true;
        setmsg ({
        type: "setMessage",
        payload: {
            ...data,
            open:true,
            type:"success",
            message:"広告新規作成に成功しました"
        }});
        history.goBack();
    }).catch((error) => {
        let errorMessage = error.errmsg;
        if (errorMessage.indexOf("'Link' failed on the 'url' tag") != -1) {
            errorMessage = "最終リンク先URLの形式が正しくありません。"
        }
        setmsg ({
            type: "setMessage",
            payload: {
                ...data,
                open: true,
                type: error.type,
                message: errorMessage,
            }
        });
    }).finally(() => {
        const resultLog: LogData = {
            ...executeLogData,
            eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
            logType: "result",
            result: isSuccess ? "成功" : "失敗",
            targetID: registedId,
            targetName: advertisement.name,
        }
        ApolloEventRecord(resultLog);
    });
    if(isSuccess) {
      window.scrollTo(0, 0);
      history.push(`${advertisements_path}zeus/${accountgroupid}/${accountid}/${platformaccountid}${queryAdGroupId}`);
    }
  };

  const handleGoBack = () => {
    // キャンセルボタンクリック時のアクション
    history.push(`${advertisements_path}zeus/${accountgroupid}/${accountid}/${platformaccountid}${queryAdGroupId}`);
  }

  return (
    <GenericTemplate title="">
      <CustomizedSnackbars/>
      <ApolloPageUsagePermission role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
        <ApolloBreadcrumbs2 data={breadcrumbsData}/>
        <AdvertisementFormZeus
          platformAccountId={Number(platformaccountid)}
          advertisementId={0}
          advertisementState={{
            advertisement: advertisement,
            setAdvertisement: setAdvertisement,
            deliveryType: deliveryType,
            setDeliveryType: setDeliveryType,
            pmpType: pmpType,
            setPmpType: setPmpType,
            placementSettingId: placementSettingId,
            setPlacementSettingId: setPlacementSettingId,
          }}
          adResourceState= {{
            titles: titles,
            setTitles: setTitles,
            titleIndexes: titleIndexes,
            setTitleIndexes: setTitleIndexes,
            isAddedTitle: isAddedTitle,
            setIsAddedTitle: setIsAddedTitle,
            descriptions: descriptions,
            setDescriptions: setDescriptions,
            descriptionIndexes: descriptionIndexes,
            setDescriptionIndexes: setDescriptionIndexes,
            isAddedDescription: isAddedDescription,
            setIsAddedDescription: setIsAddedDescription,
            images: images,
            setImages: setImages,
            imageIndexes: imageIndexes,
            setImageIndexes: setImageIndexes,
            isAddedImage: isAddedImage,
            setIsAddedImage: setIsAddedImage,
            selectedFileOrigins: selectedFileOrigins,
            setSelectedFileOrigins: setSelectedFileOrigins,
            tags: tags,
            setTags: setTags,
            tagIndexes: tagIndexes,
            setTagIndexes: setTagIndexes,
            isAddedTag: isAddedTag,
            setIsAddedTag: setIsAddedTag,
          }}
          submitAction={handleSubmit}
          goBackAction={handleGoBack}
        />
      </ApolloPageUsagePermission>
    </GenericTemplate>
  )
};

export default AdvertisementCreateZeus;
